import "./App.css";
import "./pages/Profile/tab.scss";
import { Outlet, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import { useEffect, useState } from "react";
import "sweetalert2/src/sweetalert2.scss";
import Navbar from "./components/Navbar";
import Footer from "./components/footer/Footer";
// import { generateToken, messaging } from "./notifications/firebase";
import { onMessage } from "firebase/messaging";
import Loader2 from "./components/Loader2";
import { useDispatch, useSelector } from "react-redux";
import { getGoldApi } from "./redux/features/goldSlice";

function App() {
  const location = useLocation();
  const dispatch = useDispatch();

  const { data, errors, status } = useSelector((state) => state.goldSlice);

  const shouldHideNavbar = location.pathname.includes("dashboard");

  const shouldHideFooter =
    location.pathname.includes("dashboard") ||
    location.pathname.includes("account") ||
    location.pathname.includes("login");

  const shopPath = location.pathname.includes("shop");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // useEffect(() => {
  //   generateToken();
  //   onMessage(messaging, (payload) => {
  //     // console.log(payload);
  //     // toast.success(payload.notification.body);
  //   });
  // }, []);

  // useEffect(() => {
  //   if ("serviceWorker" in navigator) {
  //     navigator.serviceWorker
  //       .register("/firebase-messaging-sw.js")
  //       .then((registration) => {})
  //       .catch((err) => {
  //         console.error("Service Worker registration failed:", err);
  //       });
  //   }
  // }, []);

  useEffect(() => {
    dispatch(getGoldApi());
  }, [dispatch]);

  return (
    <div
      className={`app_layout ${
        shouldHideNavbar ? "hide-navbar" : "home_app_layout"
      }`}
    >
      <div className={shopPath ? "shop_style" : ""}>
        {!shouldHideNavbar && <Navbar />}
      </div>
      {/* {status === "loading" && <Loader2 />} */}
      {/* {true && <Loader2 />} */}
      <Outlet />
      <div>{!shouldHideFooter && <Footer />}</div>
      {/* <Footer /> */}
    </div>
  );
}

export default App;
